<template>
  <div class="bg-secondary pa-2">
    <div class="my-10 mx-auto">
      <SubTitle :TitleName="'ストーリー'" />
      <div
        style="line-height: 1.5em;"
        class="pa-3 ma-5 text-justify text-md-center"
      >
        <p class="ma-8 text-h5">
          茨城県水戸市に位置する笹ヶ岡学園。<br />
          ここは、創立百年を超える男子校だ。
        </p>
        <p class="ma-4">
          世間では三流校として名を轟かせているが、
          一部では第二次大戦中に日本陸軍の秘密施設があったとも噂されている。
        </p>
        <p class="ma-4">
          そして、いかがわしい都市伝説もまた噂されている。<br />
          この学園の地下には日本陸軍が隠した埋蔵金が眠っているというのだ。
        </p>
        <p class="ma-4">
          また、行方不明者も後を絶たない。<br />
          五年前に歴史部の生徒四名が忽然と姿を消した記憶はまだ色あせていない。<br />
          そんな歴史部の部長が書き残した「狭間の部屋 探索記録」というノートを
          偶然手に入れてしまった三人の一年生。
        </p>
        <p class="ma-4">
          彼らは「狭間の部屋」の秘密を探るべく、
          隠された学園の地下へと足を踏み入れる。<br />
          それが身の毛もよだつ恐怖の始まりとも知らずに……。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import SubTitle from "./SubTitle.vue";

  export default {
    components: {
      SubTitle,
    },
  };
</script>
